import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const sapSelector = (state: IAppState) => state.sapCpConfiguration;

const envSelector = (state: IAppState) => state.environmentState;

export const destinationsSelector = createSelector(
  sapSelector,
  (state: ISAPGCPState) => state.sapCPConfiguration.destinations
);


export const SapConfigurationSelector = createSelector(
  sapSelector,
  (state: ISAPGCPState) => state.sapCPConfiguration.sapConfiguration
)


export const SapConfigurationsSelector = createSelector(
  sapSelector,
  (state: ISAPGCPState) => state.sapCPConfiguration.sapConfigurations
)


export const EnviromentSelector = createSelector(
  envSelector,
  (state: IEnvironmentState) => state.environment
)
